module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"iWantThis":"I want this!"},"es":{"iWantThis":"¡Lo quiero!"}}')
  delete Component.options._Ctor
}
